// @ts-nocheck
import { Column } from 'react-table'
import { InfoCell } from './InfoCell'
import { DateCell } from './DateCell'
import { StatusCell } from './StatusCell'
import { ActionsCell } from './ActionsCell'
import { SelectionCell } from './SelectionCell'
import { CustomHeader } from './CustomHeader'
import { SelectionHeader } from './SelectionHeader'
import { OfferType } from '../../core/_models'

import { format, parseISO } from 'date-fns'

const faqQnaColumns: ReadonlyArray<Column<OfferType>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <SelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Question' className='min-w-125px' />,
    id: 'question',
    Cell: ({ ...props }) => <InfoCell faqQna={props.data[props.row.index]} />,
  },

  // {
  //   Header: (props) => <CustomHeader tableProps={props} title='Answer' className='min-w-125px' />,
  //   id: 'answer',
  //   Cell: ({...props}) => <InfoCell faqQna={props.data[props.row.index]} />,
  // },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Created Date' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({ ...props }) => {
      const dateString: String = props.data[props.row.index].createdAt
      const parsedDate = parseISO(dateString)
      const formattedDate = format(parsedDate, 'MMM dd, yyyy')
      return <DateCell date={formattedDate} />
    },
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <ActionsCell id={props.data[props.row.index].id} />,
  },
]

export { faqQnaColumns }
